module.exports = __webpack_public_path__ + "img/cross.a4c2a19c.svg";